"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findCatFromOutlet = void 0;
var reconnect_js_1 = require("reconnect.js");
function findCatFromOutlet(outletKey, cat) {
  if (!(0, reconnect_js_1.hasOutlet)(outletKey)) {
    return null;
  }
  var cats = (0, reconnect_js_1.getOutlet)(outletKey).getValue();
  if (!cat) {
    return cats;
  }
  if (Array.isArray(cats)) {
    for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
      var c1 = cats_1[_i];
      if (c1.name === cat) {
        return c1;
      }
      if (Array.isArray(c1.items)) {
        for (var _a = 0, _b = c1.items; _a < _b.length; _a++) {
          var c2 = _b[_a];
          if (c2.name === cat) {
            return c2;
          }
          if (Array.isArray(c2.items)) {
            for (var _c = 0, _d = c2.items; _c < _d.length; _c++) {
              var c3 = _d[_c];
              if (c3.name === cat) {
                return c3;
              }
            }
          }
        }
      }
    }
  }
  return null;
}
exports.findCatFromOutlet = findCatFromOutlet;